
import { IGlobalState } from "@/store";
import {
  computed,
  defineComponent,
  reactive,
  toRefs,
  onMounted,
  ref,
} from "vue";
import { useStore } from "vuex";
import apiInfo from "../modules/apiInfo.vue";
import { ElMessage, ElMessageBox } from "element-plus";
import { queryApiInfoList, deleteApiById } from "@/service/api";
import { useApiGroupList } from "@/hooks/apiManage";
import { useRouter } from "vue-router";
import { useAPIGroupMenuData } from "@/hooks/doc";
import treeSelect from "../modules/treeSelect.vue";

export default defineComponent({
  components: {
    apiInfo,
    treeSelect
  },
  setup() {
    const store = useStore<IGlobalState>();
    const router = useRouter();
    const state = reactive({
      keyWord: "",
      shelfState: "-1",
      page: 1,
      limit: 10,
      total_rows: 0,
      apiInfoList: [],
      userId: computed(() => store.state.manageUser.userId),
      name: computed(() => store.state.manageUser.name),
      modalTitle: "",
      formData: {},
        //配置树形数据的label和value
      selectProp: {
        value: "id",
        label: "title"
      }
    });
    const groups = computed(() => store.state.apiManage.groups);
    const groupTreeData = computed(() => store.state.doc.groupTree);
    const loading = ref(true);
    const visibleModal = ref(false);
     /**
     * 获取API接口分组目录树
     */
    const getGroupMenuData = async () => {
      loading.value = true;
      await useAPIGroupMenuData(store);
      loading.value = false;
    };
    // /**
    //  * 获取分组列表
    //  */
    // const getApiGroupData = async () => {
    //   await useApiGroupList(store);
    // };
    // 分组id
    let groupId = computed({
      get: () => store.state.apiManage.modalAPI.groupId,
      set: (val) => {
        store.state.apiManage.modalAPI.groupId = val;
      },
    });
    /**
     * 获取api接口列表
     */
    const getApiInfoList = async () => {
      loading.value = true;
      const params = {
        shelfState: state.shelfState,
        groupId: groupId.value,
        keyWord: state.keyWord,
        page: state.page,
        limit: state.limit,
      };
      const result = await queryApiInfoList(params);
      if (result && parseInt(result.code) === 1) {
        state.apiInfoList = result.data.rows;
        state.total_rows = result.data.total_rows;
        loading.value = false;
      }
    };
    /**
     * 搜索
     */
    async function handleSearch() {
      state.page = 1;
      await getApiInfoList();
    }

    /**
     * 更多选项
     */
    const handleCommand = (command: any) => {
      if (command.type == "edit") {
        openApiModal(command.index);
      } else {
        ElMessageBox.confirm("确认删除吗？", "提示", {
          confirmButtonText: "确定",
          cancelButtonText: "取消",
          type: "warning",
        })
          .then(async () => {
            const params = {
              id: (state.apiInfoList[command.index] as any).id,
              userId: state.userId,
              userRealname: state.name,
            };
            const result = await deleteApiById(params);
            if (result && parseInt(result.code) === 1) {
              ElMessage({ message: "删除成功", type: "success" });
              handleSearch();
            } else {
              ElMessage({ message: result.msg, type: "error" });
            }
          })
          .catch(() => {});
      }
    };
    //打开添加或修改api弹窗
    function openApiModal(index: number) {
      if (index == -1) {
        state.modalTitle = "添加API接口";
        state.formData = {};
        visibleModal.value = true;
      } else {
        state.modalTitle = "修改API接口";
        state.formData = state.apiInfoList[index];
        visibleModal.value = true;
      }
    }
    //关闭弹窗
    function closeModal() {
      visibleModal.value = false;
    }
    /**
     * 跳转到参数管理
     */
    function lookParam(row: any) {
      router.push({
        path: "/openapimgeParamsMge",
        query: {
          id: row.id,
          title: row.title,
        },
      });
    }
    /**
     * 跳转到返回值管理
     */
    function lookReturnParam(row: any) {
      router.push({
        path: "/openapimgeReturnparamsmge",
        query: {
          id: row.id,
          title: row.title,
        },
      });
    }
    function headerStyle() {
      const cellStyle =
        "background: #ffffff;color: #333333;font-weight:700;width: 100%; font-size: 12px";
      return cellStyle;
    }
     //选择分组
    function handleSelect(data: any) {
      groupId.value = data[state.selectProp.value];
      handleSearch();
    }
    /**
     * 清空选择分组
     */
    function clearValue() {
      groupId.value = "";
      handleSearch();
    }
    
    /**
     * 初始加载数据
     */
    onMounted(async () => {
      // await getApiGroupData();
      await getGroupMenuData();
      await getApiInfoList();
    });
    return {
      ...toRefs(state),
      groups,
      groupTreeData,
      groupId,
      visibleModal,
      loading,
      handleSearch,
      lookParam,
      lookReturnParam,
      getApiInfoList,
      handleCommand,
      closeModal,
      openApiModal,
      headerStyle,
      clearValue,
      handleSelect
    };
  },
});
